// extracted by mini-css-extract-plugin
export var centerText = "_9y-8";
export var container = "_9y-0";
export var doughnutContainer = "_9y-7";
export var legend = "_9y-a";
export var legendItemColorDisplay = "_9y-b";
export var legendItemLabel = "_9y-d";
export var legendItemValue = "_9y-c";
export var lg = "_9y-5";
export var maxWidth = "_9y-9";
export var md = "_9y-4";
export var responsive = "_9y-6";
export var sm = "_9y-3";
export var xs = "_9y-2";
export var xxs = "_9y-1";